import {strings} from "@/utils/strings";
import clsx from "clsx";
import styles from "../styles/Ui.module.scss";
import React from "react";
import useCommon from "@/hooks/common.ts";
import {LocalLanguage} from "@/types_and_interfaces/types.ts";
import {useTranslation} from "react-i18next";

interface Props {
    className?: string
    light?: boolean
}


const LangSwitcherDesktop:React.FC<Props> = ({className, light}) => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language;
    const common_hook = useCommon()
    
    const btns = [
        {
            text: strings["ro_lang"],
            lan: "ro"
        },
        
        {
            text: strings["ru_lang"],
            lan: "ru"
        },
    ]
    
    
    return (
        <div className={clsx(styles.lang_switcher, className && className, light && styles.light)}>
            
            {btns.map((bt, i) => {
                return (
                    <button
                        onClick={() => {
                            common_hook.setSpecificLanguage((bt.lan as  LocalLanguage))
                            common_hook.langToggler()
                        }}
                        key={"ln_btn" + i}
                        disabled={currentLanguage === bt.lan}
                    >
                        {bt.text}
                    </button>
                )
            })}
        
        </div>
    )
}

export default LangSwitcherDesktop
